export default __webpack_public_path__ + "static/media/hht1_ep9_minisitcom_01.b2a6ea2b.png";